<template>
    <div>
        <div v-if="showWifiBox" class="wifi-tip-box">
            <img
                :src="closeDrawerIcon"
                class="wifi-box-close-icon"
                @click="closeWifiBox"
            >
            <div class="wifi-box-head">
                <div class="wifi-box-title">
                    温馨提示
                </div>
            </div>
            <div class="wifi-box-txt">
                当前为非WiFi环境下,是否使用流量继续下载游戏
            </div>
            <div class="wifi-box-bottom">
                <div class="wifi-box-left-btn" @click="closeWifiBox">
                    <div class="wifi-box-left-btn-txt">
                        取消
                    </div>
                </div>
                <div class="wifi-box-right-btn" @click="resumeDownloadClick">
                    <div class="wifi-box-right-btn-txt">
                        继续下载
                    </div>
                </div>
            </div>
        </div>
        <div class="mask"></div>
    </div>
</template>

<script>
import {getQueryString} from '@/utils/url';
import CloseDrawerIcon from 'public/assets/imgs/xiuxiu_panel_close.png';
export default {
    props: {
        showWifiBox: {
            type: Boolean,
            default: false,
        },
        appName: {
            type: String,
            default: '',
        },
        appType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            closeDrawerIcon: CloseDrawerIcon,
        };
    },
    created() {
        this.$logger.display({
            value: 'showWifiTips',
            ext: {
                item: [
                    {
                        ext: {
                            appName: this.appName,
                            sid: getQueryString('sid') || '',
                            fromPage: getQueryString('isNewStyle') ? 'detail' : 'zone',
                            srcId: getQueryString('srcId') || '',
                            appType: this.appType,
                            moduleName: 'wifiTips',
                        },
                    },
                ],
            },
        });

    },
    methods: {
        closeWifiBox() {
            this.$emit('closeWifiBox', false);
            this.doClickLog('cancelClick');
        },
        resumeDownloadClick() {
            this.$emit('closeWifiBox', false);
            this.$emit('resumeDownloadClick', true);
            this.doClickLog('continueClick');
        },
        doClickLog(type) {
            let content = {
                value: type,
                ext: {
                    id: '',
                    ext: {
                        sid: getQueryString('sid') || '',
                        fromPage: getQueryString('isNewStyle') ? 'detail' : 'zone',
                        srcId: getQueryString('srcId') || '',
                        appType: this.appType,
                        moduleName: 'wifiTips',
                        clickPos: type === 'cancelClick' ? '取消' : '继续下载',
                    },
                },
            };
            this.$logger.click(content);
        },
    },
};
</script>

<style scoped lang="scss">
.wifi-tip-box {
    width: 993px;
    height: 575px;
    background: #FFFFFF;
    border: 1px solid rgba(0,0,0,0.05);
    border-radius: 27px;
    position: relative;
    z-index: 1030;
    .wifi-box-close-icon {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 36px;
        right: 36px;
    }
    .wifi-box-head {
        margin-top: 90px;
        margin-left: 352px;
        .wifi-box-title {
            width: 264px;
            height: 66px;
            font-family: PingFangSC-Regular;
            font-size: 66px;
            color: #333333;
            letter-spacing: 0;
            line-height: 66px;
            font-weight: 400;
        }
    }
    .wifi-box-txt {
        margin-left: 65px;
        margin-top: 60px;
        width: 862px;
        height: 123px;
        font-family: PingFangSC-Regular;
        font-size: 48px;
        color: #858585;
        letter-spacing: 0;
        line-height: 80px;
        font-weight: 400;
    }
    .wifi-box-bottom {
        display: flex;
        align-items: center;
        margin-top: 90px;
        .wifi-box-left-btn {
            width: 496px;
            height: 148px;
            font-family: PingFangSC-Regular;
            font-size: 54px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
            line-height: 148px;
            font-weight: 400;
            text-align: center;
            border-top: 1px solid rgba(224,224,224,1);
            border-left: 1px solid rgba(224,224,224,1);
            border-bottom: 1px solid rgba(224,224,224,1);
            border-bottom-left-radius: 27px;
        }
        .wifi-box-right-btn {
            width: 496px;
            height: 148px;
            font-family: PingFangSC-Regular;
            font-size: 54px;
            color: #3388FF;
            letter-spacing: 0;
            text-align: center;
            line-height: 148px;
            font-weight: 400;
            text-align: center;
            border: 1px solid rgba(224,224,224,1);
            border-bottom-right-radius: 27px;
        }
    }
}
.mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1020;
}
</style>